import { createClient } from '@supabase/supabase-js'

// Fonction sécurisée pour créer le client Supabase
export function safeCreateSupabase() {
  try {
    const url = import.meta.env.VITE_SUPABASE_URL;
    const anon = import.meta.env.VITE_SUPABASE_ANON_KEY;
    
    // Debug des variables d'environnement
    console.log('[SUPABASE] URL:', url ? '✅ Configurée' : '❌ MANQUANTE');
    console.log('[SUPABASE] Key:', anon ? '✅ Configurée (longueur: ' + anon?.length + ')' : '❌ MANQUANTE');
    
    // Vérification des variables d'environnement
    if (!url || !/^https?:\/\//.test(url) || !anon) {
      console.error('[Supabase] Missing/invalid config', { 
        urlPresent: !!url, 
        urlValid: url ? /^https?:\/\//.test(url) : false,
        anonPresent: !!anon 
      });
      return null; // Ne pas jeter d'erreur
    }
    
    // Création du client Supabase
    const client = createClient(url, anon, {
      auth: {
        autoRefreshToken: true,
        persistSession: true,
        detectSessionInUrl: true,
        flowType: 'pkce',
        storage: window.localStorage,
        storageKey: 'memomundi-auth-token'
      },
      global: {
        headers: {
          'X-Client-Info': 'memomundi-web'
        }
      }
    });
    
    console.log('✅ Client Supabase initialisé avec succès');
    return client;
    
  } catch (error) {
    console.error('[Supabase] init failed', error);
    return null; // Ne pas jeter d'erreur
  }
}

// Export du client (peut être null si config invalide)
export const supabase = safeCreateSupabase();

// Fonction de test de connexion
export const testSupabaseConnection = async () => {
  if (!supabase) {
    return { success: false, message: 'Client Supabase non initialisé', error: 'Configuration manquante' };
  }
  
  try {
    console.log('🔍 Test de connexion Supabase...')
    
    // Test simple : vérifier la connexion à la table users
    const { data, error } = await supabase
      .from('users')
      .select('count')
      .limit(1)
    
    if (error) {
      // Erreur RLS normale = connexion OK
      console.log('✅ Connexion Supabase OK (RLS actif):', error.message)
      return { success: true, message: 'Connexion établie', error: error.message }
    }
    
    console.log('✅ Connexion Supabase OK:', data)
    return { success: true, message: 'Connexion établie', data }
    
  } catch (err) {
    console.error('❌ Erreur de connexion Supabase:', err)
    return { success: false, message: 'Erreur de connexion', error: err }
  }
}

// Export par défaut
export default supabase